import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {currentResource} from '../../util/utils';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function canvasFormCountriesReducer(state = initialState.canvasFormCountries, action) {
	switch (action.type) {
		case types.GET_CANVASFORM_COUNTRYS: {
			if (!action) return state;
			if (action.response) {
				let options = [];
				action.response.forEach(function(opt) {
					options.push({
						value: opt.cgCountryID,
						label: opt.countryName
					});
				});
				return options;
			}
			if (action.response == null && action.error?.response.status === HttpStatusCodes.Forbidden) {
				return {};
			}
		}
		case types.CLEAR_CANVASFORM_COUNTRYS: {
			return initialState.canvasFormCountries;
		}
		default:
			return state;
	}
}

export function canvasFormLanguagesReducer(state = initialState.canvasFormLanguages, action) {
	switch (action.type) {
		case types.GET_CANVASFORM_LANGUAGES: {
			if (!action) return state;
			if (action.response) {
				let options = [];
				action.response.forEach(function(opt) {
					options.push({
						value: opt.languageId,
						label: opt.languageName,
						isPCAOB: opt.isPCAOB,
						pcaobReferenceLanguageId: opt.pcaobReferenceLanguageId
					});
				});
				return options;
			}
			if (action.response == null && action.error?.response.status === HttpStatusCodes.Forbidden) {
				return {};
			}
		}
		case types.CLEAR_CANVASFORM_LANGUAGES: {
			return initialState.canvasFormLanguages;
		}
		default:
			return state;
	}
}

export function canvasFormTypesReducer(state = initialState.canvasFormTypes, action) {
	switch (action.type) {
		case types.GET_CANVASFORM_TYPES: {
			if (!action) return state;
			if (action.response && action.response.cgFormTypeData) {
				return action.response.cgFormTypeData;
			}
			if (action.response == null && action.error?.response.status === HttpStatusCodes.Forbidden) {
				return {};
			}
		}
		case types.CLEAR_CANVASFORM_TYPES: {
			return initialState.canvasFormTypes;
		}
		case types.CLOSE_CANVAS_FORM_COMBINED: {
			return initialState.canvasFormTypes;
		}
		default:
			return state;
	}
}

export function GAMLayerWithCountryLanguageReducer(state = initialState.GAMLayerWithCountryLanguage, action) {
	switch (action.type) {
		case types.SET_CANVASFORM_GAMLAYER_WITH_COUNTRY_LANGUAGE: {
			return {...state, ...action.object};
		}
		case types.CLEAR_CANVASFORM_GAMLAYER_WITH_COUNTRY_LANGUAGE: {
			return initialState.GAMLayerWithCountryLanguage;
		}
		case types.CLOSE_CANVAS_FORM_COMBINED: {
			return initialState.GAMLayerWithCountryLanguage;
		}
		default:
			return state;
	}
}

export function UIActionReducer(state = initialState.createManualCanvasFormUIState, action) {
	switch (action.type) {
		case types.SET_CREATE_MANUAL_FORM_SUCCESS_MESSAGE: {
			let oldState = {...state};
			oldState.successMessage = action.successMessage;
			oldState.hasInterval = action.hasInterval;
			return oldState;
		}
		case types.SET_IS_ADD_CANVAS_FORM_MODAL_OPEN: {
			let oldState = {...state};
			oldState.isModalOpen = action.isOpen;
			oldState.formTypeId = action.formTypeId;
			return oldState;
		}
		default:
			return state;
	}
}
export function serviceLinesReducer(state = initialState.serviceLines, action) {
	switch (action.type) {
		case types.GET_SERVICE_LINE: {
			if (!action) return state;
			if (action.response) {
				return getLocalizedSubServiceLines(action);
			}
			if (action.response == null && action.error?.response.status === HttpStatusCodes.Forbidden) {
				return [];
			}
		}
		case types.CLEAR_SERVICE_LINE: {
			return initialState.serviceLines;
		}
		default:
			return state;
	}
}

/**
 * This function useful to pick sub-service lines from resource file and translate.
 * @param {Object} action - Action object containing response and other values.
 * @return {Array} transformed sub-service lines based on user preferred language.
 */
function getLocalizedSubServiceLines(action) {
	let alteredServiceLines = [];
	var localizedEngagementSubServiceLines = currentResource.SubServiceLines;

	_.each(action.response, function(serviceLine) {
		if (serviceLine && serviceLine.subServiceLines) {
			let alteredSubServiceLines = [];

			_.forEach(serviceLine.subServiceLines, (subServiceLine) => {
				let localSubServiceLineItem = localizedEngagementSubServiceLines.find(
					(x) => x.subServiceLineId == subServiceLine.subServiceLineId
				);
				let subServiceFinalName = localSubServiceLineItem
					? localSubServiceLineItem.subServiceLineName
					: subServiceLine.subServiceLineName;
				alteredSubServiceLines.push({
					subServiceLineId: subServiceLine.subServiceLineId,
					subServiceLineName: subServiceFinalName
				});
			});

			alteredServiceLines.push({
				serviceLineId: serviceLine.serviceLineId,
				serviceLineName: serviceLine.serviceLineName,
				subServiceLines: alteredSubServiceLines
			});
		}
	});

	return alteredServiceLines;
}
